import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css'; // Импортируем стили

const ProfileSkeleton = () => {
  return (
    <div className="profile">
      {/* Скелетон для заголовка */}
      <section className="profile__header">
        <div className="profile__greeting">
          <p className="profile__greeting-text">
            <Skeleton width={100} height={20} />
          </p>
          <p className="profile__greeting-name">
            <Skeleton width={150} height={25} />
          </p>
        </div>
        <div className="profile__actions">
          <Skeleton width={120} height={40} />
          <Skeleton width={180} height={40} />
        </div>
      </section>

      {/* Скелетон для блока с фото и именем */}
      <section className="profile__header">
        <h2 className="profile__section-title-prof">
          <Skeleton width={200} height={25} />
        </h2>
        <div className="profile_header-bloc">
          <div className="profile__photo">
            <Skeleton circle width={100} height={100} />
          </div>
          <div className="profile__name">
            <h1 id="first-name">
              <Skeleton width={120} height={25} />
            </h1>
            <h1 id="last-name">
              <Skeleton width={120} height={25} />
            </h1>
          </div>
        </div>
        <div className="profile__stats">
          <div className="profile__stat">
            <p className="profile__stat-label">
              <Skeleton width={60} height={20} />
            </p>
            <p id="posts-count" className="profile__stat-value">
              <Skeleton width={40} height={20} />
            </p>
          </div>
          <div className="profile__stat">
            <p className="profile__stat-label">
              <Skeleton width={80} height={20} />
            </p>
            <p id="subscribers-count" className="profile__stat-value">
              <Skeleton width={40} height={20} />
            </p>
          </div>
          <div className="profile__stat">
            <p className="profile__stat-label">
              <Skeleton width={60} height={20} />
            </p>
            <p id="friends-count" className="profile__stat-value">
              <Skeleton width={40} height={20} />
            </p>
          </div>
        </div>
      </section>

      {/* Скелетон для блока активности */}
      <section className="profile__analysis">
        <div className="profile__activity">
          <div className="profile__activity-column">
            {[...Array(6)].map((_, index) => (
              <div className="profile__activity-items" key={index}>
                {/* Упрощенный скелетон для каждого элемента активности */}
                <Skeleton width={100} height={100} /> {/* Общий блок для иконки, текста и значения */}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSkeleton;
